'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor(name, purpose, location, dataCategories, safeguards, dpaStatus, dpaUrl, privacyUrl) {
  this.gF = null;
  this.j0 = null;
  this.iY = null;
  this.iV = null;
  this.j1 = null;
  this.iW = null;
  this.iX = null;
  this.iZ = null;
  this.gF = name;
  this.j0 = purpose;
  this.iY = location;
  this.iV = dataCategories;
  this.j1 = safeguards;
  this.iW = dpaStatus;
  this.iX = dpaUrl;
  this.iZ = privacyUrl;
}
export { $c_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor as $c_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor };
$p = $c_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor as $h_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor };
$h_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-103291249), true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor) && ((((((((this.gF === x$0.gF) && (this.j0 === x$0.j0)) && (this.iY === x$0.iY)) && (this.iV === x$0.iV)) && (this.j1 === x$0.j1)) && (this.iW === x$0.iW)) && (this.iX === x$0.iX)) && (this.iZ === x$0.iZ))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 8;
});
$p.I = (function() {
  return "Subprocessor";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.gF;
      break;
    }
    case 1: {
      return this.j0;
      break;
    }
    case 2: {
      return this.iY;
      break;
    }
    case 3: {
      return this.iV;
      break;
    }
    case 4: {
      return this.j1;
      break;
    }
    case 5: {
      return this.iW;
      break;
    }
    case 6: {
      return this.iX;
      break;
    }
    case 7: {
      return this.iZ;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bR)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor as $isArrayOf_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor };
var $d_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor, "io.intela.sites.digitalinternship.data.Subprocessors$Subprocessor", ({
  bR: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor as $d_Lio_intela_sites_digitalinternship_data_Subprocessors$Subprocessor };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Subprocessors$-Subprocessor.js.map
